import axios from "axios";
import momentTimezone from "moment-timezone";


import modalNotification from "../utils/notification";
import { API_BASE_URL } from "./env";
import { store } from "../redux/store";
import toast from "react-hot-toast";
import { logout } from "../redux/slices/auth.slice";

let isRefreshing = false;

let pendingQueue = [];

const drainQueue = (token = null, err = null) => {
  pendingQueue.forEach((entry) => {
    if (token) {
      entry.resolve(token);
    } else {
      entry.reject(err);
    }
  });

  pendingQueue = [];
};

const APIrequest = async ({
  method = "GET",
  url,
  baseURL,
  queryParams,
  bodyData,
  formHeaders,
  removeHeaders,
}) => {
  // const getToken = () =>
  // getLocalStorageToken() || getCookie(TOKEN_KEY);
  // getLocalStorageToken();

  const axiosConfig = {
    method,
    baseURL: baseURL || API_BASE_URL,
    headers: {
      "X-Frame-Options": "sameorigin",
      timezone: momentTimezone.tz.guess(true),
    },
  };

  try {
    axiosConfig.headers = axiosConfig.headers || {};

    if (bodyData instanceof FormData) {
      axiosConfig.headers["Content-Type"] =
        "multipart/form-data";
    } else {
      axiosConfig.headers["Content-Type"] =
        "application/json";
    }

    if (formHeaders) {
      axiosConfig.headers = {
        ...axiosConfig.headers,
        ...formHeaders,
      };
    }

    // if (SECURITY_TOKEN) {
    //   axiosConfig.headers["X-API-Key"] = SECURITY_TOKEN;
    // }

    if (url) {
      axiosConfig.url = url;
    }

    if (queryParams) {
      const queryParamsPayload = {};

      for (const key in queryParams) {
        if (
          Object.prototype.hasOwnProperty.call(
            queryParams,
            key
          )
        ) {
          const element =
            typeof queryParams[key] === "string"
              ? queryParams[key].trim()
              : queryParams[key];

          if (![undefined, null, "", NaN].includes(element)) {
            queryParamsPayload[key] = element;
          }
        }
      }

      axiosConfig.params = queryParamsPayload;
    }

    if (bodyData instanceof FormData) {
      axiosConfig.data = bodyData;
    } else if (Array.isArray(bodyData)) {
      axiosConfig.data = bodyData;
    } else if (typeof bodyData === "object") {
      const bodyPayload = {};

      for (const key in bodyData) {
        if (
          Object.prototype.hasOwnProperty.call(
            bodyData,
            key
          )
        ) {
          const element =
            typeof bodyData[key] === "string"
              ? bodyData[key].trim()
              : bodyData[key];

          if (![undefined, NaN].includes(element)) {
            bodyPayload[key] = element;
          }
        }
      }

      axiosConfig.data = bodyPayload;
    }

    if (removeHeaders) {
      delete axiosConfig.headers;
    }

    // Fetch the token directly from Redux store state
    const currentToken = store.getState().auth?.token;


    if (currentToken) {
      axiosConfig.headers = {
        ...axiosConfig.headers,
        authorization: `Bearer ${currentToken}`,
      };
    }

    const res = await axios(axiosConfig);

    return res.data;
  } catch (error) {
    if (!error.response) {
      modalNotification({
        type: "error",
        message:
          "Unable to connect to server. Please try again later.",
      });

      console.log("Network error / Server unreachable", error);

      return null;
    }

    // const refreshToken = getCookie(REFRESH_TOKEN_KEY);

    if (axios.isCancel(error)) {
      console.log("API canceled", error);
    }

    const errorRes = error?.response;

    if (errorRes?.data?.errors?.length) {
      modalNotification({
        type: "warning",
        message: errorRes?.data?.errors?.[0]?.msg,
      });
    }

    if (errorRes?.status === 401) {
      store.dispatch(logout())
      toast.error("Unauthorized, Login again")
      window.location.href = "/";
      return null;
    }

    // if (errorRes?.status === 401 && refreshToken) {
    //   if (isRefreshing) {
    //     try {
    //       const newToken = await new Promise(
    //         (resolve, reject) => {
    //           pendingQueue.push({ resolve, reject });
    //         }
    //       );

    //       axiosConfig.headers = {
    //         ...axiosConfig.headers,
    //         authorization: `Bearer ${newToken}`,
    //       };

    //       const retryRes = await axios(axiosConfig);

    //       return retryRes.data;
    //     } catch {
    //       return null;
    //     }
    //   }

    //   isRefreshing = true;

    //   const newToken = await refreshAccessToken();

    //   isRefreshing = false;

    //   if (newToken) {
    //     drainQueue(newToken);

    //     axiosConfig.headers = {
    //       ...axiosConfig.headers,
    //       authorization: `Bearer ${newToken}`,
    //     };

    //     try {
    //       const retryRes = await axios(axiosConfig);

    //       return retryRes.data;
    //     } catch {}
    //   } else {
    //     drainQueue(null, new Error("Token refresh failed"));
    //   }

    //   forceLogout();

    //   return null;
    // }

    // if (errorRes?.status === 401 && !refreshToken) {
    //   modalNotification({
    //     type: "error",
    //     message:
    //       errorRes?.data?.message ||
    //       "Session expired. Please log in again.",
    //   });

    //   return null;
    // }

    if (errorRes?.status === 500) {
      console.error(
        "500 ERROR FULL RESPONSE:",
        errorRes
      );

      modalNotification({
        type: "error",
        message:
          errorRes?.data?.message ||
          errorRes?.data?.error?.description ||
          errorRes?.data?.error ||
          "Something went wrong on server",
      });

      return errorRes.data;
    }

    if (
      (errorRes?.status === 400 ||
        errorRes?.status === 404) &&
      errorRes.data.message
    ) {
      modalNotification({
        type: "warning",
        message: errorRes.data.message,
      });

      return errorRes.data;
    }

    if (errorRes?.status === 429) {
      modalNotification({
        type: "error",
        message:
          errorRes.data.message ||
          errorRes.data.error?.description,
      });
    }

    if (errorRes?.status === 409) {
      modalNotification({
        type: "error",
        message:
          errorRes.data.message ||
          errorRes.data.error?.description,
      });
    }

    if (errorRes?.status === 422) {
      modalNotification({
        type: "error",
        message:
          errorRes.data.message ||
          errorRes.data.error?.description,
      });
    }

    if (errorRes?.data?.error?.length > 0) {
      modalNotification({
        type: "error",
        message: errorRes.data.error[0]?.message,
      });
    }

    return null;
  }
};

export default APIrequest;